{
  "plus": {
    "profile": {
      "cancel": "",
      "validate": "",
      "next": "",
      "enable": "",
      "disable": "",
      "twoFactorAuth": {
        "sms": "",
        "confirmationModalSms": ""
      }
    }
  },
  "actions": {
    "enable": "Ota käyttöön"
  },
  "mmbRefundForm": {
    "links": {
      "recloceticket": {
        "link": {
          "url": "/fi/1859614-1859614"
        },
        "text": "Mikä on varaustunnukseni tai e-lippuni numero?"
      },
      "refund": {
        "link": {
          "url": "/fi/2664430-2664430"
        },
        "text": "Mikä on takaisinmaksuhakemukseni tila?"
      }
    },
    "submitText": "Etsi varaus",
    "submitAria": "Etsi varaus",
    "recLocNotFoundError": "Emme löytäneet varaustasi. Varmistathan, että sukunimi ja varausviite on syötetty oikein, ja yritä uudelleen.",
    "recLocAlreadyCancelledError": "Tämä varaus on jo peruttu, mutta emme ole vielä vastaanottaneet palautuspyyntöä. Täytäthän palautuslomakkeen saadaksesi hyvityksen.",
    "recLocTourOperatorError": "Tämä varaus on tehty matkatoimiston kautta. Otathan suoraan yhteyttä matkatoimistoosi peruuttaaksesi varauksen ja pyytääksesi hyvitystä."
  }
}
